<button
  mat-button
  class="fz-search__icon"
  (click)="appearance() === 'icon' ? toggleExpanded($event) : null"
>
  <mat-icon>
    {{ isSearchExpanded() ? 'arrow_back' : 'search' }}
  </mat-icon>
</button>
<form
  [formGroup]="searchForm"
  class="fz-search__form"
  (ngSubmit)="formSubmit($event)"
>
  @if (isSearchExpanded() || appearance() === 'default') {
    <input
      #searchInput
      class="fz-search__form__input"
      type="search"
      name="search"
      enterkeyhint="search"
      [attr.placeholder]="placeholder()"
      formControlName="search"
      data-testid="search-input"
    />
  }

  @if (searchForm.value.search) {
    <button
      class="fz-search__form__clear"
      type="reset"
      mat-button
      color="tertiary"
    >
      Clear
    </button>
  }
</form>
